/* RepeatDayRenderer.js */

"use strict";
const DateTimePickerPopup = require("../../common_components/date_time_picker_popup/DateTimePickerPopupComponent");
const StartEndComponent = require("../../grid_row_components/start_end_component/StartEndComponent");
const BaseScheduleRenderer = require("../../base/BaseScheduleRenderer");
const RendererUtils = require("../../base/RendererUtils");

class RepeatDayRenderer extends BaseScheduleRenderer {
    constructor(model) {
        super(model);
    }
    render(formContainerElem) {
        if (this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._atPickerComp = new DateTimePickerPopup(this._model, "time");
                this._startEndComp = new StartEndComponent(this._model);
                this._atParts = RendererUtils.groupGridRowElements(
                    formContainerElem,
                    "at",
                    "At",
                    this._atPickerComp
                );
                return this._atPickerComp.renderer.render();
            })
            .then(() => {
                return this._startEndComp.renderer.render(formContainerElem);
            })
            .then(() => {
                this._setTheme(this._model.theme);
                this._registerListeners();
                this.setRendered(true);
            });
    }
    getParts() {
        return this._atParts.concat(this._startEndComp);
    }
    shutdown() {
        if (!this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                return Promise.all([
                    super.shutdown(),
                    this._atPickerComp.shutdown(),
                    this._startEndComp.shutdown(),
                ]);
            })
            .then(() => {
                this._atParts = undefined;
                this._atPickerComp = undefined;
                this._startEndComp = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _setControlValuesFromModel() {}
}
module.exports = RepeatDayRenderer;
